export default (state, action) => {
  switch (action.type) {
    case "NEW_GAME_PENDING":
    case "JOIN_GAME_PENDING":
      return {
        ...state,
        game: { ...state.game, loading: true, error: null },
      };
    case "NEW_GAME_SUCCESS":
    case "JOIN_GAME_SUCCESS":
      return {
        ...state,
        game: { ...action.payload, loading: false, error: null },
        players: action.payload.players || [],
        // currentPlayerId is only returned on create/join, never on poll.
        currentPlayerId: action.payload.currentPlayerId ?? state.currentPlayerId,
      };
    case "NEW_GAME_ERROR":
    case "JOIN_GAME_ERROR":
    case "GAME_ERROR":
      return {
        ...state,
        game: { ...state.game, loading: false, error: action.payload },
      };
    case "GAME_STATE_UPDATED":
      return {
        ...state,
        game: { ...state.game, ...action.payload, loading: false, error: null },
        players: action.payload.players || state.players,
      };
    case "RESET_GAME":
      return {
        game: null,
        players: [],
        currentPlayerId: null,
      };
    default:
      return state;
  }
};
